<div class="PGResourceAssociation">
    @if (isLoading) {
        <app-pg-loading></app-pg-loading>
    }
    @if (!isLoading) {
        <div class="row">
            <div class="col">
                <div class="PGResourceAssociation-Field">
                    <app-pg-list-editor [readonly]="readonly || isSaving" [resource]="resourceId" [resourceMode]="resourceMode" [resourceSemantic]="resourceSemantic" [ngModel]="selectedElementsString" (ngModelChange)="onSelectedElementsChange($event)" [ignoreValuesList]="ignoreValuesList"></app-pg-list-editor>
                </div>
            </div>
        </div>
    }
</div>
